import { render, staticRenderFns } from "./liveaboardcommentFinish.vue?vue&type=template&id=3554e25c&scoped=true&"
import script from "./liveaboardcommentFinish.vue?vue&type=script&lang=js&"
export * from "./liveaboardcommentFinish.vue?vue&type=script&lang=js&"
import style0 from "./liveaboardcommentFinish.vue?vue&type=style&index=0&id=3554e25c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3554e25c",
  null
  
)

export default component.exports